<template>
    <section>
        <v-dialog v-model="dialog" persistent max-width="880px">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    <v-flex>Transaction Details</v-flex>
                    <v-btn icon @click="CloseDialog">
                        <v-icon color="text--secondary">close</v-icon>
                    </v-btn>
                    </v-card-title>
                <v-card-text>
                    <v-flex wrap style="padding: 10px;">
                        <v-layout row style="border: 1px solid lightgray;margin-bottom:4px;">
                            <v-flex xs9 pa-2>
                                <span style="font-size: 15px;font-weight: bold;"> Transaction Id : </span> 
                                <span> {{ Transaction_Ref_Id }} </span>
                            </v-flex>
                            <v-flex xs3 pa-2>
                                <span style="font-size: 15px;font-weight: bold;"> Date : </span> 
                                <span> {{ new Date(Transaction_Date).toLocaleDateString() }} </span>
                            </v-flex>
                        </v-layout> 
                        <v-flex pa-2 style="border: 1px solid lightgray;margin-bottom:4px;">
                           <span style="font-size: 15px;font-weight: bold;"> Purchaser Email : </span> 
                           <span> {{ Email }} </span>
                        </v-flex>            
                        <v-flex pa-2 style="border: 1px solid lightgray;margin-bottom:4px;">
                           <span style="font-size: 15px;font-weight: bold;"> Applied Coupon : </span> 
                           <span> {{ Coupon_Code ? Coupon_Code : "Coupon Not Applied" }} </span>
                        </v-flex>
                        <v-layout row style="border: 1px solid lightgray;margin-bottom:4px;">
                            <v-flex xs3 pa-2>
                                <span style="font-size: 15px;font-weight: bold;"> Course Title </span> 
                            </v-flex>
                            <v-flex xs3 pa-2>
                                <span style="font-size: 15px;font-weight: bold;"> Course Type </span> 
                            </v-flex>
                            <v-flex xs2 pa-2>
                                <span style="font-size: 15px;font-weight: bold;"> Price </span> 
                            </v-flex>
                            <v-flex xs2 pa-2>
                                <span style="font-size: 15px;font-weight: bold;"> Discount </span> 
                            </v-flex>
                            <v-flex xs2 pa-2>
                                <span style="font-size: 15px;font-weight: bold;"> Amount Paid </span> 
                            </v-flex>
                        </v-layout>
                        <v-layout style="border-left: 1px solid lightgray;border-right: 1px solid lightgray;border-bottom: 1px solid lightgray;" row v-for="( course_item,index ) in Course_Details" :key="index">
                            <v-flex xs3 pa-2>
                                <span> {{ course_item.Course_Title }} </span>
                            </v-flex>
                            <v-flex xs3 pa-2>
                                <span> {{ CourseTypeLabel(course_item.Course_Type) }} </span>
                            </v-flex>
                            <v-flex xs2 pa-2>
                                <span>Rs.    {{ course_item.Actual_Amount }} </span>
                            </v-flex>
                            <v-flex xs2 pa-2>
                                <span>Rs. {{ course_item.Discount }} </span>
                            </v-flex>
                            <v-flex xs2 pa-2> 
                                <span>Rs. {{ course_item.Discounted_Amount }} </span>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-card-text>
            </v-card>
        </v-dialog>
  </section>
</template>
<script>
import { CourseTypeLabel } from '../../util/courseTypes'

export default {
    props: ['dialog'],
    data(){
        return {
            Course_Details      : [],
            Transaction_Ref_Id  : "",
            Transaction_Date    : null,
            Email               : "",
            Coupon_Code         : ""
        }
    },
    methods:{
        CourseTypeLabel,
        CloseDialog(){
            this.Transaction_Ref_Id = ''
            this.Transaction_Date   = null
            this.Email              = ''
            this.Coupon_Code        = ''
            this.Course_Details     = []
            this.$emit('close')
        },
        DisplayDetails(Item){
            
            Item.forEach(element => {

                this.Transaction_Ref_Id = element['Transaction_Ref_Id']
                this.Transaction_Date   = element['Transaction_Date']
                this.Email              = element['Email']
                this.Coupon_Code        = element['Coupon_Code']
                this.Course_Details.push({
                    Course_Title  : element['Course_Title'],
                    Course_Type   : element['Course_Type'],
                    Actual_Amount : element['Actual_Amount'],
                    Discount      : element['Discount'],
                    Discounted_Amount : element['Discounted_Amount'],
                })
            });
        }    
    }
}
</script>
<style scoped>
.flexPadding{
    padding: 8px;
}
</style>